import GoogleAnalyticsCore from './GoogleAnalyticsCore';

import Logger from '../../functions/logging';

class GoogleAnalyticsEventAdapter extends GoogleAnalyticsCore {
	reportAnalyticsEvent(aevent) {

		try {
			Logger.log(this.constructor.name, "Logging event to google Event analytics :", aevent.gaEventSet);
			//this.dispatchEvent(this.addLabeltoEvent(aevent.gaEventSet,aevent.simulatedURL,aevent.fullURL));
			this.dispatchEvent(aevent);


			//Logger.log(this.className + ' : the following event was emitted', this.addLabeltoEvent(aevent.gaEventSet,aevent.simulatedURL,aevent.fullURL));
		} catch (e) {
			// Do nothing, we don't want to interrupt the flow because of a reporting
			// failure. Just quietly log it.
			throw (this.constructor.name + ' Unable to log to Google Event Analytics : ' + e.message);
		}
	}
}

export default GoogleAnalyticsEventAdapter;


// WEBPACK FOOTER //
// ./src/analytics/google-analytics-adapter/GoogleAnalyticsEventAdapter.js